import * as setTourComplete from "@/api/tourComplete";

export default {
	namespaced: true,
	state: {
		error: null,
	},
	getters: {
		readError: (state) => {
			return state.error;
		},
	},
	mutations: {
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async setTourComplete({ commit, rootGetters }) {
			const token = rootGetters["loginStore/readToken"];
			let setTourCompleteRes = await setTourComplete
				.setTourComplete(token)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return setTourCompleteRes;
		},
	},
};
